// MarketerConsultantModals.jsx — 마케터 1:1 관리의 창(모달) 모음 (2026-10-06)
//   PC·휴대폰 화면이 같이 쓰도록 페이지에서 한 번만 그린다.
//   배정 추가·수정 / 이동·끝내기 / 배정 상세 / 마케터 고르기 / 급여 조건 / 변경 기록 (상담자배분은 2026-10-06 세 번째 탭으로)
import React from 'react';
import { AssignmentModal } from './AssignmentModal';
import { AssignmentMoveModal } from './AssignmentMoveModal';
import { AssignmentDetailSheet } from './AssignmentDetailSheet';
import { MarketerPickerSheet } from './MarketerPickerSheet';
import { AssignmentRulesSheet } from './AssignmentRulesSheet';
import { MarketerConsultantHistoryModal } from './MarketerConsultantHistoryModal';

function countsByMarketer(rows = []) {
  return rows.reduce((acc, row) => {
    const id = Number(row.marketer_user_id);
    acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});
}

// 급여 조건을 바꾸면 배정 목록과 1:1급여 계산을 같이 다시 불러온다(calc.handleRulesChanged)
export function MarketerConsultantModals({ vm, board, actions, calc = null, history, today, integratedMenuId }) {
  return (
    <>
      {vm.modal && (
        <AssignmentModal
          mode={vm.modal.mode}
          form={vm.form}
          marketers={vm.marketers}
          consultants={vm.consultants}
          lockedMarketer={vm.modal.lockedMarketer}
          assignment={vm.modal.assignment || null}
          saving={vm.saving}
          error={vm.formErr}
          onField={vm.setField}
          onSave={vm.handleSave}
          onClose={vm.closeModal}
        />
      )}

      {vm.moveModal && (
        <AssignmentMoveModal
          mode={vm.moveModal.mode}
          assignment={vm.moveModal.assignment}
          targetMarketer={vm.moveModal.targetMarketer}
          saving={vm.saving}
          error={vm.moveErr}
          onSave={vm.handleMoveSave}
          onClose={vm.closeMoveModal}
        />
      )}

      <AssignmentDetailSheet
        row={actions.detailRow}
        today={today}
        saving={vm.saving}
        onClose={actions.closeDetail}
        onMove={actions.requestMove}
        onEnd={actions.requestEnd}
        onEdit={actions.requestEdit}
        onRules={actions.requestRules}
        onDelete={actions.requestDelete}
        onHistory={(row) => { actions.closeDetail(); history.openForAssignment(row); }}
      />

      <MarketerPickerSheet
        picker={actions.picker}
        marketers={board.allMarketers}
        hiddenIds={board.hiddenIds}
        countsByMarketer={countsByMarketer(board.currentAssignments)}
        onPick={actions.pickMarketer}
        onClose={actions.closePicker}
      />

      <AssignmentRulesSheet
        row={actions.rulesRow}
        integratedMenuId={integratedMenuId}
        onChanged={() => (calc ? calc.handleRulesChanged() : vm.loadData(vm.activeTab))}
        onClose={actions.closeRules}
      />

      {/* 열 때마다 거르기·찾기 글자를 처음으로(key) */}
      <MarketerConsultantHistoryModal
        key={`${history.open}-${history.scope}-${history.row?.id || ''}`}
        history={history}
        companyName={vm.activeCompanyName}
      />
    </>
  );
}
